import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemName } from '../../../../lib/models/Form';
import { FormItem } from '../../../../components/FormItem';
import { FormInput } from '../../../../components/FormInput';

const addressLineTwo = 'unique.formItems.addressLineTwo';

export const AddressLineTwoFormItem: FC = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.ADDRESS_LINE_TWO}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },

        { max: 100 },
      ]}
    >
      <FormInput label={t(`${addressLineTwo}.label`)} />
    </FormItem>
  );
};
